import React from 'react';
import './reassurance.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Grid } from '../../Grid/grid';
import { Image } from '../../Media';
import { TextWithLine } from '../../../Marketing/Banners/BannerText/bannerText';
import { sidebarState } from '../../../../utils/recoil/sidebar';
import { useRecoilState } from 'recoil';
import { Body, Button } from '../../Elements';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { useDrawer } from 'utils/recoil/drawer';

const closeButton = <Button icon={{ iconKey: 'HiOutlineX', size: '2xl' }} />;

export const ReassuranceItem = ({ image, title, body, color, index }) => {
  const drawer = useDrawer();

  const handleOnClick = () => {
    drawer.open({
      placement: 'right',
      closeButton,
      title: null,
      actionButton: null,
      width: 'lg:w-screen/3 w-screen-95',
      body: (
        <div className='p-4'>
          <div className='relative flex flex-col h-auto'>
            <div className='h-1/2 overflow-hidden w-full'>
              <Image {...image} objectFit='cover' width='100%' />
            </div>
            <div className='h-1/2 mt-4 flex flex-col justify-center text-left items-start'>
              {body && <Body {...body} />}
            </div>
          </div>
        </div>
      ),
      footer: null,
      backdropLink: null,
    });
  };

  return (
    <li
      onClick={handleOnClick}
      className='relative text-center w-full h-full flex flex-col hover:text-black'
    >
      <div className=' cursor-pointer hover:underline whitespace-nowrap space-x-6 flex flex-row items-center'>
        {index === 0 && (
          <div
            className='w-2 h-2 bg-gray-400  rounded-full'
            style={{ top: '9px' }}
          ></div>
        )}
        <Label {...title} icon={null} />
        <div
          className={`w-2 h-2 bg-${color.classname}  rounded-full`}
          style={{ top: '9px' }}
        ></div>
      </div>
    </li>
  );
};

export const Reassurance = ({ list, label }) => (
  <section className='sticky border-t py-6 top-16 z-30 flex justify-center'>
    <div className='bg-white w-screen h-full absolute inset-0'></div>
    <div className='main-wrapper flex overflow-scroll no-scrollbar space-x-6'>
      {list.items.map((reassurance, key) => (
        <ReassuranceItem
          {...formatContentfulComponentProps(reassurance)}
          index={key}
        />
      ))}
    </div>
  </section>
);
